import { Route, Switch } from 'wouter';
import InvoicesPage from '@/components/InvoicesPage/InvoicesPage';
import InvoiceDetailsPage from '@/components/InvoicesPage/InvoiceDetailsPage';
import CreateInvoicePage from './CreateInvoicePage';

export default function InvoicesPageWrapper() {
  return (
    <Switch>
      <Route path="/create" component={CreateInvoicePage} />
      <Route path="/:id" component={InvoiceDetailsPage} />
      <Route path="/" component={InvoicesPage} />
    </Switch>
  );
}
